import React from 'react';
import styled from 'styled-components';
import type { Platform } from '../../data/types';

const labels: Record<Platform, string> = {
  ios: 'iOS',
  macos: 'macOS',
  web: 'Web',
  wechat: 'WeChat',
  workflow: 'Workflow',
};

const List = styled.ul<{ $onDark?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 0;
  list-style: none;
`;

const Badge = styled.li<{ $onDark?: boolean }>`
  padding: 6px 10px;
  color: ${({ $onDark, theme }) => ($onDark ? theme.colors.accentPale : theme.colors.accentStrong)};
  background: ${({ $onDark }) => ($onDark ? 'rgba(255,255,255,0.08)' : 'rgba(99,102,241,0.08)')};
  border: 1px solid ${({ $onDark }) => ($onDark ? 'rgba(255,255,255,0.14)' : 'rgba(99,102,241,0.16)')};
  border-radius: ${({ theme }) => theme.radii.pill};
  font-size: 0.76rem;
  font-weight: 750;
  letter-spacing: 0.025em;
`;

const PlatformBadges: React.FC<{ platforms: readonly Platform[]; onDark?: boolean }> = ({ platforms, onDark = false }) => (
  <List $onDark={onDark} aria-label="Platforms">
    {platforms.map((platform) => <Badge key={platform} $onDark={onDark}>{labels[platform]}</Badge>)}
  </List>
);

export default PlatformBadges;
